import { get, post } from '@/plugins/axios'

/**
* 组合商品分页
* @param {Object} params
*/
export function getCombinationList (data: any) {
  return post('/order/combination/product/page', data)
}

/**
* 组合商品添加到购物车
* @param {Object} data
*/
export function combinationAddCart (data: any) {
  return post('/order/combination/product/addCart', data)
}

/**
* 完结
* @param {Object} data
*/
export function combinationFinished (data: any) {
  return post('/order/customer/platformOrderItem/finishToRemainCombinationQuantity', data)
}

/**
* 编辑组合商品附加项
* @param {Object} data
*/
export function additionEdit (data: any) {
  return post('/order/combination/product/additionEdit', data)
}
